import { LocationIcon } from '#app/components/icons'

export default {
	name: 'Proof of Exhibition',
	slug: 'proofOfExhibition',
	description: "Capture an artwork's IRL events and exhibitions",
	version: '1.0.0',
	icon: <LocationIcon />,
	countersign: 'Optional',
	fields: [
		{
			name: 'Start Date',
			slug: 'startDate',
			required: true,
			type: 'date',
			placeholder: 'Select a Date',
		},
		{
			name: 'End Date',
			slug: 'endDate',
			required: true,
			type: 'date',
			placeholder: 'Select a Date',
		},
		{
			name: 'Name',
			slug: 'name',
			required: true,
			type: 'text',
			placeholder: 'The name of the Exhibition',
		},
		{
			name: 'Location',
			slug: 'location',
			required: false,
			type: 'text',
			placeholder: 'The location of the exhibition',
		},
		{
			name: 'Owner Address',
			slug: 'ownerAddress',
			required: true,
			type: 'text',
			placeholder: 'The Address of the Owner',
		},
		{
			name: 'Receiver Address',
			slug: 'receiverAddress',
			required: true,
			type: 'text',
			placeholder: 'The Address of the Receiver',
		},
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'Details about or a description of the exhibition',
		},
		{
			name: 'Artist Name',
			slug: 'artistname',
			required: false,
			type: 'text',
			placeholder: 'Artist Name for Exhibition',
		},
		{
			name: 'URL',
			slug: 'url',
			required: false,
			type: 'text',
			placeholder: 'The URL for the Exhibition',
		},
		{
			name: 'Image URL',
			slug: 'imageURL',
			required: false,
			type: 'text',
			placeholder: 'The Image URL for the Exhibition',
		},
		{
			name: 'Countersign Required',
			slug: 'countersignRequired',
			required: false,
			type: 'boolean',
			hidden: true,
			placeholder: 'Does this require a countersign?',
		},
		{
			name: 'Artist Initiated',
			slug: 'artistInitiated',
			required: false,
			type: 'boolean',
			default: true,
			hidden: true,
			placeholder: 'Is this being initated by the artist?',
		},
	],
	info: '',
}
